/**
 * Helpers for pilot Excel export date filtering (local calendar day, inclusive).
 * Default "after 6 May 2026" → inclusive from 7 May 2026 local midnight.
 */

export const DEFAULT_EXPORT_FROM_YMD = '2026-05-07';

/**
 * @param {string} ymd `YYYY-MM-DD`
 * @returns {Date} start of that calendar day in the runtime local timezone
 */
export function localYmdToStartDate(ymd) {
  const raw = String(ymd || '').trim();
  if (!/^\d{4}-\d{2}-\d{2}$/.test(raw)) {
    return localYmdToStartDate(DEFAULT_EXPORT_FROM_YMD);
  }
  const [y, m, d] = raw.split('-').map((x) => Number(x));
  if ([y, m, d].some((n) => !Number.isFinite(n))) {
    return localYmdToStartDate(DEFAULT_EXPORT_FROM_YMD);
  }
  return new Date(y, m - 1, d, 0, 0, 0, 0);
}

/**
 * Normalize row `createdAt` from Firestore (Timestamp, ISO string, etc.) to epoch ms.
 * @param {Record<string, unknown>} row
 * @returns {number | null}
 */
export function documentCreatedAtToMillis(row) {
  const v = row.createdAt;
  if (v == null) return null;
  if (typeof v === 'number' && Number.isFinite(v)) return v;
  if (typeof v === 'string') {
    const t = Date.parse(v);
    return Number.isNaN(t) ? null : t;
  }
  if (typeof v === 'object' && typeof v.toDate === 'function') {
    try {
      return v.toDate().getTime();
    } catch {
      return null;
    }
  }
  if (v instanceof Date) return v.getTime();
  return null;
}
